import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

import { DIALOG_TYPE as DIALOG_HELP_SUPPORT } from './types';

export const doHelpSupportModal = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    id: 'DIALOG_HELP_SUPPORT',
    type: DIALOG_HELP_SUPPORT,
    allowNesting: false,
  }),
);
